import React from 'react'
import styled, {withTheme} from 'styled-components'
import get from 'lodash/get'
import breakpoint from 'components/breakpoint'
import {getLocationSetter} from 'utils/browserUtils'
import config from 'config'
import {ELEMENTS_IDS} from 'const'
import Logo from 'components/Logo'

const LogosContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;

  ${breakpoint('portrait')`
    flex-direction: row;
    align-items: center;
    justify-content: center;
  `}
`

const BrandLogo = styled(Logo)`
  height: ${props => props.height || '22px'};

  &:first-of-type {
    margin-bottom: 15px;
  }

  &:last-of-type {
    margin-right: 0;
  }

  ${breakpoint('portrait')`
    margin-right: 40px;
    flex-direction: row;
    align-items: center;
    height: ${props => get(props.portrait, 'height', '26px')};

    &:first-of-type {
      margin-right: 40px;
      margin-bottom: 0;
    }
  `};
`

const HeaderLogos = ({theme}) => {
  const icons = [theme.shell.header.icon, ...theme.shell.header.additionalIcons]

  return (
    <LogosContainer>
      {icons.map(({image, href, height, portrait}) => (
        <BrandLogo
          key={image}
          className={ELEMENTS_IDS.brandLogo}
          src={`${config.url}/assets/${image}`}
          onClick={getLocationSetter(href)}
          height={height}
          portrait={portrait}
        />
      ))}
    </LogosContainer>
  )
}

export default withTheme(HeaderLogos)
